import { useEffect, useState } from 'react';
import { fetchStreamInfo } from '../../../net/channel-api';
import { useProject } from '../../context';

/**
 * The title the channel has on ompeer.com, for a form to start from while the studio holds no
 * title of its own; '' while unknown (no stream key, another destination, the API out of reach).
 * Asked again whenever the studio's own title goes away: it was just published, or cleared.
 */
export function useChannelTitle(): string {
  const swarm = useProject((p) => p.output.streaming.mode === 'swarm');
  const apiUrl = useProject((p) => p.output.streaming.swarmApiUrl);
  const streamKey = useProject((p) => p.output.streaming.swarmStreamKey);
  const hasOwn = useProject((p) => p.channel.info.title !== '');
  const [title, setTitle] = useState('');

  useEffect(() => {
    if (hasOwn || !swarm) return;
    let cancelled = false;
    void (async () => {
      try {
        const stream = await fetchStreamInfo({ apiUrl, streamKey });
        if (!cancelled) setTitle(stream?.title ?? '');
      } catch {
        // Unknown: the form's title box stays empty.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [hasOwn, swarm, apiUrl, streamKey]);

  return title;
}

/** What a form stores of what it shows: a title that is only the channel's own is not the studio's to keep or send. */
export const ownTitle = (shown: string, channelTitle: string): string => (shown === channelTitle ? '' : shown);
